import { useSelector } from 'react-redux';
import { ReportSummaryCoreSection } from '../../models/reports.interface';
import { selectReportSummaryReportSectionsCoreSections } from '../../selectors';

export const useSelectReportSectionsConfig = (): ReportSummaryCoreSection[] => {
  const selectReportSectionsCoreSections = useSelector(selectReportSummaryReportSectionsCoreSections);

  return selectReportSectionsCoreSections;
};
